module.exports = __webpack_public_path__ + "img/laveu.f54e9ce4.svg";